import validator from "validator";
import { toast } from "react-toastify";
import moment from 'moment';
import 'moment/locale/he';
import { PhoneNumberUtil } from "google-libphonenumber";
import { UAParser } from 'ua-parser-js';


const phoneUtil = PhoneNumberUtil.getInstance();

export const checkEmailFormate = (value) => {
  if (value) {
    return validator.isEmail(value);
  }
};

export function handleCopyToClipboard(value, type, t ) {
  navigator.clipboard.writeText(value);

  let toastMessage = t("copied");
  let toastId = null;

  switch (type) {
    case "doctor":
      toastMessage = t("Doctor's link copied");
      toastId = "doctor-toast";
      break;
    case "client":
      toastMessage = t("Client's link copied");
      toastId = "client-toast";
      break;
    case "guest":
      toastMessage = t("Guest's link copied");
      toastId = "guest-toast";
      break;
    case "zoom":
      toastMessage = "Password copied";
      toastId = "zoom-toast";
      break;
    default:
      toastMessage = "copied";
      toastId = "default-toast";
      break;
  }

  if (!toast.isActive(toastId)) {
    toast.success(toastMessage, { toastId });
  }
}

export const formatDate = (date) => {
  return moment(date).format('DD/MM/YY HH:mm');
};

export const debounce = (callback, delay) => {
  let timeout;

  return (...args) => {
    // Clear the existing timeout
    if (timeout) {
      clearTimeout(timeout);
    }

    // Set a new timeout
    timeout = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};


export function validateIsraeliID(id) {
	id = String(id).trim();
	if (id.length > 9 || isNaN(id)) return false;
	id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
		return Array.from(id, Number).reduce((counter, digit, i) => {
			const step = digit * ((i % 2) + 1);
			return counter + (step > 9 ? step - 9 : step);
		}) % 10 === 0;
}

export const isMobile = () => {
  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isMobileUA =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  return isTouchDevice || isMobileUA;
};

// Function to format the ISO date to  the browser locale.
export const formattedDate = (isoDate) => {
  const date = moment(isoDate);

  if (!date.isValid()) {
    return 'תאריך לא חוקי'; // "Invalid date" in Hebrew
  }

  return date.locale('he').format('L'); // Localized short date format
};

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
};

export const countHashes = (str = "") =>
  (str.match(/#/g) || []).length;

// Dosage is held as a string so the field can survive intermediate states like
// "2." while typing. An <input type="number"> reports "" for those, which on
// soft keyboards wipes the entry and makes a decimal dosage impossible to type.
export const sanitizeDosageInput = (value) => {
  const digitsAndDots = String(value ?? "")
    .replace(/,/g, ".")
    .replace(/[^0-9.]/g, "");
  const [whole, ...decimals] = digitsAndDots.split(".");
  return decimals.length ? `${whole}.${decimals.join("")}` : whole;
};

export const isValidDosage = (value) => {
  const parsed = Number(sanitizeDosageInput(value));
  return Number.isFinite(parsed) && parsed > 0;
};

// The API expects dosage as a JSON number. Blank stays blank so an unfinished
// autosave never persists a 0 that would later read back as a missing dosage.
export const withNumericDosage = (prescriptionRows = []) =>
  prescriptionRows.map((row) => {
    if (row?.dosage === undefined || row?.dosage === null || row?.dosage === "") {
      return row;
    }
    return { ...row, dosage: Number(row.dosage) };
  });

export const validateMobile = (mobile, t) => {
  if (!mobile) {
    return t("Please enter mobile number");
  }

  if (mobile.length > 20) {
    return t("Mobile number max length 20");
  }

  if (!mobile.startsWith("05") && !mobile.startsWith("+")) {
    return t("Phone number must start with 05 or +.");
  }

  try {
    const parsedNumber = phoneUtil.parse(mobile, "IL");
    if (!phoneUtil.isValidNumber(parsedNumber)) {
      return t("Invalid phone number.");
    }
  } catch (err) {
    return t("Invalid phone number.");
  }

  return ""; // valid → no error
};

export const getDeviceInfo = () => {
  const parser = new UAParser();
  const result = parser.getResult();
  const deviceType = result.device.type
    ? result.device.type // mobile / tablet / etc.
    : "desktop"; // undefined means desktop

  return {
    os: result.os.name
      ? `${result.os.name} ${result.os.version || ""}`.trim()
      : "Unknown",
    browser: result.browser.name
      ? `${result.browser.name} ${result.browser.version || ""}`.trim()
      : "Unknown",
    device: deviceType,
  };
};

export const formattedDOB = (date) => {
  if (!date || !moment(date).isValid()) {
    return null;
  }
  return moment(date).hour(12).minute(0).locale("en").toISOString();
};

export const formatDateForFilter = (date, type = "start") => {
  if (!date || !moment(date).isValid()) return null;

  const m =
    type === "start"
      ? moment(date).startOf("day")
      : moment(date).endOf("day");

  return m.format("YYYY-MM-DD HH:mm:ss");
};